import { defaultAxios, IParams } from './base';

export interface IGetUserCertComplete extends IParams {
  txSeqNo: string;
}

export const getUserCertComplete = (params: any) => {
  return defaultAxios().post(`/loan/certCheck`, params);
};
